<template>
<div class="chapter">
<div class="inner_page">
<p class="fm-head">CONTENTS</p>
<p class="toc"><a href="#/Introduction">Introduction</a></p>
<p class="toc1"><a href="#/Chapter1#C1">1. Ichetucknee Springs: Canoe Port, Kidnapping and a Lover’s Lagoon</a></p>
<p class="toc"><span href="#/Chapter2#C2" title="Link target outside of Sample">2. Manatee Spring: The White King’s Party, an Important Alligator and a Sublime Spring</span></p>
<p class="toc"><span href="#/Chapter3#C3" title="Link target outside of Sample">3. Troy Spring: Lost Cities of Troy, a Runaway and an Unforgettable Steamboat</span></p>
<p class="toc"><span href="#/Chapter4#C4" title="Link target outside of Sample">4. Fanning Springs: A Fort, a Ferris Wheel and Florida Giants</span></p>
<p class="toc"><span href="#/Chapter5#C5" title="Link target outside of Sample">5. Boulware Spring and the Water War</span></p>
<p class="toc"><span href="#/Chapter6#C6" title="Link target outside of Sample">6. White Spring: Taking the Water and Drinking the Kool-Aid</span></p>
<p class="toc"><span href="#/Chapter7#C7" title="Link target outside of Sample">7. Rum Island Spring: Moonshine and a Mayor</span></p>
<p class="toc"><span href="#/Chapter8#C8" title="Link target outside of Sample">8. Silver Springs, Paradise Park and Spring Segregation</span></p>
<p class="toc"><span href="#/Chapter9#C9" title="Link target outside of Sample">9. Weeki Wachee and the Florida Mermaid</span></p>
<p class="toc"><span href="#/Chapter10#C10" title="Link target outside of Sample">10. Lily Spring and Florida’s Last Hermit</span></p>
<p class="toc"><span href="#/Chapter11#C11" title="Link target outside of Sample">11. Ginnie Springs: Body Counts and a Whirling Vortex</span></p>
<p class="toc1"><span href="#/Bibliography" title="Link target outside of Sample">Bibliography</span></p>
<p class="toc"><span href="#/Author" title="Link target outside of Sample">About the Author</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Contents.vue?30b8ea65